export default function NotFound() {
    return (
        <div className="px-4 pt-4">
            <h1 className="fs-4 mb-0">Page not found.</h1>
        </div>
    );
}